import React, { useState } from 'react'
import { Avatar, Box, Divider, IconButton, Menu, MenuItem } from '@mui/material'
import { ExitToAppSharp, Notifications, Settings } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { useAuth } from 'hooks/auth/useAuth'

export const CoreAccountCluster: React.FC = () => {
  const navigate = useNavigate()
  const { userInfo, logout } = useAuth()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const role = userInfo?.role

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        color='inherit'
        onClick={event => setAnchorEl(event.currentTarget)}
        size='small'
        aria-label='Account menu'
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        <Avatar sx={{ width: 32, height: 32 }} src={userInfo?.profilePicture || undefined}>
          {userInfo?.first_name?.[0]}
          {userInfo?.last_name?.[0]}
        </Avatar>
      </IconButton>
      <Menu
        id='account-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        onClick={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            border: 1,
            borderColor: 'divider',
            mt: 1,
            minWidth: 200,
          },
        }}
      >
        {role && (role === 'admin' || role === 'babyAdmin') && (
          <MenuItem
            onClick={() => {
              navigate('/notification-center')
            }}
          >
            <Notifications fontSize='small' sx={{ mr: 1 }} />
            Notification Center
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            navigate('/account-settings')
          }}
        >
          <Settings fontSize='small' sx={{ mr: 1 }} />
          Settings
        </MenuItem>
        <Divider />
        <MenuItem
          onClick={async () => {
            await logout()
          }}
          sx={{ color: 'error.main' }}
        >
          <ExitToAppSharp fontSize='small' sx={{ mr: 1 }} />
          Logout
        </MenuItem>
      </Menu>
    </Box>
  )
}
